import React from "react";
import MUIRadio, { RadioProps as MUIRadioProps } from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";

/**
 * Props to use when instantiating a `radio button` component.
 */
export interface RadioProps extends MUIRadioProps {
  /**
   * Disable the button.
   */
  disabled?: boolean;

  /**
   * Optional label
   */
  label?: React.ReactNode;

  /**
   * Optional label placement
   */
  labelPlacement?: "top" | "start" | "bottom" | "end";

  /**
   * Optional value
   */
  value?: string;

  /**
   * Optional param to pass a custom color to the radio button.
   */
  customColor?: string;
}

/**
 * A `radio button` component.
 */
export function Radio({
  disabled = false,
  label,
  labelPlacement = "end",
  value,
  customColor,
  ...radioProps
}: RadioProps) {
  const radio = (
    <MUIRadio
      disabled={disabled}
      sx={
        customColor
          ? {
              color: customColor,
              "&.Mui-checked": {
                color: customColor
              }
            }
          : {}
      }
      {...radioProps}
    />
  );

  if (label) {
    return (
      <FormControlLabel
        value={value || label}
        control={radio}
        label={label}
        labelPlacement={labelPlacement}
      />
    );
  }

  return radio;
}
